export const INCENTIVE_HEADER_TOP_PADDING = 70;
